module.exports = __webpack_public_path__ + "img/logo.cd3c4fd2.svg";